<script setup lang="ts">
import { getStrCell } from '@/utils/file';

export interface Stop {
  name?: string;
  isTruckHere?: boolean;
  isTruckBefore?: boolean;
}

export interface Props {
  stops?: Stop[];
}
const props = withDefaults(defineProps<Props>(), {
  stops: () => [],
});
</script>

<template>
  <div :class="$style.thinJobStopDiagram" data-testid="thinJobStopDiagram">
    <div :class="$style.stops">
      <div :class="$style.road"></div>
      <div v-if="!props.stops.length" :class="$style.stop">
        <div :class="$style.numMarkerTitle">
          <div :class="$style.marker">
            <v-icon icon="mdi-map-marker"></v-icon>
          </div>
        </div>
      </div>
      <div
        v-for="(stop, index) in props.stops"
        :key="index"
        :class="$style.stop"
      >
        <div
          v-if="stop.isTruckHere"
          :class="[$style.truck, { [$style.truckBefore]: stop.isTruckBefore }]"
        >
          <v-icon icon="mdi-truck-fast-outline"></v-icon>
        </div>
        <div :class="$style.numMarkerTitle">
          <div :class="$style.stopNum">Stop {{ index + 1 }}</div>
          <div :class="$style.marker">
            <v-icon icon="mdi-map-marker"></v-icon>
          </div>
          <div :class="$style.stopTitle">{{ getStrCell(stop.name) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.thinJobStopDiagram {
  line-height: 1.4;
}
  .stops {
    display: flex;
    min-width: variables.$thinJobStopDiagramPadding + variables.$thinJobStopDiagramStopWidth;
    padding-left: variables.$thinJobStopDiagramPadding;
    position: relative;
    z-index: 0;
  }
    .road {
      height: 1px;
      background-color: colors.$color-text-tertiary;
      width: 100%;
      position: absolute;
      z-index: -1;
      margin-top: 41px;
      margin-left: -#{variables.$thinJobStopDiagramPadding};
    }
    .stop {
      padding-right: variables.$thinJobStopDiagramStopPadding;
      width: 100%;
    }
      .truck {
        color: colors.$color-text-secondary;
        font-size: 20px;
        position: absolute;
        margin-top: 12px;
        margin-left: 60px;
      }
      .truckBefore {
        margin-left: -40px;
      }
      .numMarkerTitle {
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        min-height: 83px;
      }
        .marker {
          border: 2px solid colors.$color-text-tertiary;
          color: colors.$color-text-tertiary;
          background-color: colors.$color-white;
          border-radius: 50%;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 27px;
          height: 27px;
          font-size: 11px;
          margin: 6px 0 6px 12px;
        }
        .stopNum {
          color: colors.$color-text-primary;
          font-size: 16px;
          font-weight: 500;
        }
        .stopTitle {
          color: colors.$color-text-secondary;
          font-size: 16px;
          font-weight: 400;
          width: variables.$thinJobStopDiagramStopTitleWidth;
        }
</style>
